<ul class="option-switcher">
  @for (option of options(); track $index) {
    <li
      class="option-switcher__item option"
      [ngClass]="{ active: option.id === selectedOptionId() }"
    >
      <button
        type="button"
        class="option__button"
        [disabled]="isDisabled() || disabled() || option.disabled"
        [tooltip]="option.tooltip || undefined"
        (click)="onSelect(option.id)"
      >
        @if (option.icon) {
          @if (isIcomoonIcon(option.icon)) {
            <i class="option__button_icon icon" [ngClass]="option.icon"> </i>
          } @else {
            <img
              class="option__button_icon"
              loading="lazy"
              alt="Delivery"
              [src]="option.icon"
            />
          }
        }

        <span class="option__button_label">
          <h5 class="option__button_name">{{ option.name }}</h5>

          @if (option?.description) {
            <p
              class="option__button_description"
              [innerHtml]="processDescription(option.description)"
            ></p>
          }
        </span>
      </button>
    </li>
  }
</ul>
